<!--
/**
* @name: Login.vue
* @description: 登录模板
* @author: 温永江
* @create: 2020/07/22 15:55:18
* @update: 2020/07/22 15:55:18
*/
-->

<template>
  <div :class="css.lo">
    <div :class="css.box" v-dnd.limit>
      <div class="text-center" style="margin-bottom: 40px; pointer-events: none;">
        <img src="../assets/images/login-logo.png" />
      </div>
      <div @mousedown.stop>
        <k-input placeholder="用户名" autofocus v-model="username" block size="huge" @keyup.enter="$refs.pwd.focus">
          <k-icon name="icon-yonghu" slot="prepend" :class="css.icon" />
        </k-input>
      </div>
      <div :class="css.g" @mousedown.stop>
        <k-input ref="pwd" v-if="isPassword" block type="password" size="huge" placeholder="密码" v-model="password" @keyup.enter="onLogin">
          <k-icon name="icon-chanpinku" slot="prepend" :class="css.icon" />
          <!-- <img src="../assets/images/icon-show.png"  style="width:22px;height:22px"/> -->
        </k-input>
        <!-- <k-input ref="pwd" v-else block type="text" size="huge" placeholder="密码" v-model="password" @keyup.enter="onLogin">
          <k-icon name="icon-chanpinku" slot="prepend" :class="css.icon" />
          <img src="../assets/images/icon-hide.png"  style="width:22px;height:22px"/>
        </k-input> -->
      </div>
      <div :class="css.g" @mousedown.stop>
        <k-button @click="onLogin" size="huge" type="primary" :loading="loading" block>登录</k-button>
      </div>
      <!-- <div :class="css.g">
        <a href="javascript:void(0);"
          @click="navigateTo('forgetPassword')">忘记密码</a>
      </div> -->
    </div>
  </div>
</template>
<script>
import { NESTLE_SYSTEM_BACK_SERVER_LOGIN } from "@/assets/modules/apiList";

export default {
  data() {
    return {
      username: "",
      password: "",
      isPassword: true,
      // loading: false
    };
  },
  computed: {
    keep() {
      const q = this.$route.query;
      return q && q.keep == 1;
    },
  },
  methods: {
    goHome() {
      this.$router.replace({ name: "main" });
    },
    navigateTo(name) {
      this.$router.replace({ name });
    },
    async removeStorage() {
      // 清除快捷页签数据
      this.$lf.removeItem("currentMenu");
      this.$lf.removeItem("currentSubMenu");
      this.$lf.removeItem("quickMenu");
      this.$lf.removeItem("lastMenuIds");
      // 清除从后台请求的基础数据
      // await this.$lf.keys().then(keys => {
      //   keys.forEach(k => {
      //     const kk = k.toLowerCase();
      //     if (/api\//.test(kk)) {
      //       this.$lf.removeItem(k);
      //     }
      //   });
      // });
    },
    async setLoginInfo(info) {
      await this.$lf.setItem("login", info);
    },
    async onLogin() {
      if (this.loading) {
        return;
      }
      if (!this.username || !this.password) {
        return this.$root.tip("请输入用户名/密码", "error");
      }
      this.loading = true;
      try {
        const login = await this.$fetch({
          api: NESTLE_SYSTEM_BACK_SERVER_LOGIN,
          para: this.$data,
        });
        const lastLogin = await this.$lf.getItem("login");
        this.loading = false;
        if (!lastLogin) {
          await this.removeStorage();
        } else {
          const lastUserId = lastLogin.username;
          if (lastUserId != login.username) {
            await this.removeStorage();
          } else {
            const { keep } = this;
            if (!keep) {
              await this.removeStorage();
            }
          }
        }
        this.setLoginInfo(login).then(this.goHome);
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="postcss" module="css">
.lo {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
  background-image: url(/img/login.jpg);
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;

  & .box {
    width: 480px;
    padding: 50px 80px 60px;
    border-radius: 4px;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.5), 2px 2px rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.8);

    @supports (backdrop-filter: blur(20px)) {
      backdrop-filter: blur(25px);
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  & .g {
    margin-top: 25px;
  }

  & .icon {
    width: 20px;
    height: 18px;
    color: #aaa;
  }
}
</style>
